import { Skeleton } from '@higo/ui';
import styled from 'styled-components';

export const MeasurementSkeleton = styled(Skeleton)`
  height: 1.365625rem; // font-size * line-height
  width: 100%;
`;
